export const Easings = {
  // no easing, no acceleration
  linear: (t: TODOAny) => t,
  // accelerating from zero velocity
  quadIn: (t: TODOAny) => t * t,
  // decelerating to zero velocity
  quadOut: (t: TODOAny) => t * (2 - t),
  // acceleration until halfway, then deceleration
  quadInOut: (t: TODOAny) => (t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t),
  // accelerating from zero velocity
  cubicIn: (t: TODOAny) => t * t * t,
  // decelerating to zero velocity
  cubicOut: (t: TODOAny) => (t - 1) ** 3 + 1,
  // acceleration until halfway, then deceleration
  cubicInOut: (t: TODOAny) =>
    t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1,
  // elastic bounce effect at the beginning
  elasticIn: (t: TODOAny) => (0.04 - 0.04 / t) * Math.sin(25 * t) + 1,
  // elastic bounce effect at the end
  elasticOut: (t: TODOAny) => {
    const t1 = t - 1
    return ((0.04 * t) / t1) * Math.sin(25 * t1)
  },
  // elastic bounce effect at the beginning and end
  elasticInOut: (t: TODOAny) =>
    t - 0.5 < 0
      ? (0.02 + 0.01 / t) * Math.sin(50 * t)
      : (0.02 - 0.01 / t) * Math.sin(50 * t) + 1,
  sinIn: (t: TODOAny) => 1 + Math.sin((Math.PI / 2) * t - Math.PI / 2),
  sinOut: (t: TODOAny) => Math.sin((Math.PI / 2) * t),
  sinInOut: (t: TODOAny) => (1 + Math.sin(Math.PI * t - Math.PI / 2)) / 2,
  // jump to end at 1
  stepEnd: (t: TODOAny) => (t < 1 ? 0 : 1),
  // only stay in start when 0
  stepStart: (t: TODOAny) => (t > 0 ? 1 : 0),
  circleIn: (t: TODOAny) => 1 - Math.sqrt(1 - t * t),
  circleOut: (t: TODOAny) => Math.sqrt(1 - (t - 1) ** 2),
  circleInOut: (t: TODOAny) => {
    const t2 = t * 2
    return (
      (t2 <= 1
        ? 1 - Math.sqrt(1 - t2 ** 2)
        : Math.sqrt(1 - (t2 - 2) ** 2) + 1) / 2
    )
  },
  expInOut: (t: TODOAny) => {
    const t2 = t * 2
    return (t2 <= 1 ? 2 ** (10 * t2 - 10) : 2 - 2 ** (10 - 10 * t2)) / 2
  },
  expOut: (t: TODOAny) => 1 - 2 ** (-10 * t),
  expIn: (t: TODOAny) => 2 ** (10 * t - 10),
}

export type PossibleEasings = keyof typeof Easings

export const DEFAULT_EASING = 'quadInOut'
